import React, { useState, useEffect, memo } from 'react';

const TextViewer = ({ fileUrl, onLoad }) => {
  const [content, setContent] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!fileUrl) return;

    const controller = new AbortController();
    setIsLoading(true);
    setError(null);

    fetch(fileUrl, { signal: controller.signal })
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        // res.text() preserves the file content as-is; JSON.stringify was corrupting it in V1
        return res.text();
      })
      .then((text) => {
        setContent(text);
        setIsLoading(false);
        onLoad?.();
      })
      .catch((err) => {
        if (err.name === 'AbortError') return;
        setError('Failed to load file content.');
        setIsLoading(false);
      });

    return () => controller.abort();
  }, [fileUrl, onLoad]);

  return (
    <div className="text-viewer">
      {isLoading && (
        <div className="viewer-loading">
          <div className="spinner-border text-primary" role="status" aria-label="Loading text">
            <span className="visually-hidden">Loading…</span>
          </div>
        </div>
      )}

      {error && (
        <div className="viewer-error" role="alert">
          <i className="icon-warning me-2" />
          {error}
        </div>
      )}

      {!isLoading && !error && <pre className="text-viewer__content">{content}</pre>}
    </div>
  );
};

export default memo(TextViewer);
